import React, { useState } from 'react';
import { Button } from 'components/Button';
import { Modal } from 'components/modal/Modal';
import { FormGroup } from 'components/form/FormGroup';
import { FormField } from 'components/form/FormField';
import { FormSelect } from 'components/form/FormSelect';
import './GeneratePdfModal.scss';
/**
 * @component GeneratePdfModal
 * @since 1.0.0
 */
export function GeneratePdfModal(props) {
    const { onClose, onConfirm } = props;
    const [format, setFormat] = useState('COMPACT');
    const options = [
        { value: 'COMPACT', label: t('Compact') },
        { value: 'DETAILED', label: t('Detailed') }
    ];
    const footerActions = (React.createElement("div", { className: "generate-pdf-modal-footer" },
        React.createElement(Button, { label: t('Cancel'), onPress: onClose }),
        React.createElement(Button, { style: "primary", label: t('Download'), onPress: () => onConfirm(format) })));
    return (React.createElement("div", { className: "generate-pdf-modal" },
        React.createElement(Modal, { title: t('Download PDF'), onClose: onClose, showFooterAction: true, footerActions: footerActions },
            React.createElement("div", { className: "generate-pdf-modal-content" },
                React.createElement(FormGroup, null,
                    React.createElement(FormField, null,
                        React.createElement(FormSelect, { name: "format", label: t('Format'), placeholder: t('Select Format'), options: options, value: format, onChange: (value) => setFormat(value), required: true })))))));
}
